// TODO: Use shared commonTypes.

export interface IdToObjectMap<T> {
  [key: string]: T;
}

export interface IRefreshablePropSubState<T> {
  prop?: T;
  isFetching: boolean;
  error?: string;
}

export interface IRemoteActionSubState<T> {
  response?: T;
  succeeded?: boolean;
  isPosting: boolean;
  error?: string;
}

export interface IListSubState {
  isFetching: boolean;
  ids: string[];
  error?: string;
}

export const emptyListSubState: IListSubState = {
  isFetching: false,
  ids: []
};

export function createObjectsMap<T extends { uid?: string }>(
  objects: T[]
): IdToObjectMap<T> {
  const maps: IdToObjectMap<T> = {};
  objects.forEach(s => {
    maps[s.uid!] = s;
  });
  return maps;
}

export function objectSubset<T>(map: IdToObjectMap<T>, ids: string[]) {
  if (!ids) {
    return [];
  }

  const subset: T[] = [];
  ids.map(id => {
    const object = map[id];
    if (object) {
      subset.push(map[id]);
    } else {
      console.warn(`Failed to find object ${id}`);
    }
  });
  return subset;
}

export interface IFormField<T> {
  data?: T;
  error?: string;
}



// WEBPACK FOOTER //
// ./src/state/model/SharedTypes.ts